import Param from '../../param';
import Util from '../../util';
import effectManager from '../effect';

const param = new Param();
const effect = new effectManager();
const util = new Util();

/* ---------------------------------------

    -- マウス動作に合わせていい感じに値を返すやつ

--------------------------------------- */

export default class MouseManager{
    constructor(inc){

        /* ポインターの位置情報 */
        this.pointer = {
            x : 0,
            y : 0
        }
        /* 慣性動作後の値 */
        this.obj = {
            x : 0,
            y : 0
        }

        /* 設定はここ */
        this.conf = {
            ease : 0.2,
        }

    }
    move(type){ /* domにスタイル付けるなら("set",$target) | 値が欲しいだけなら()なし */

        this.obj.x += (this.pointer.x-this.obj.x)*this.conf.ease;
        this.obj.y += (this.pointer.y-this.obj.y)*this.conf.ease;
    }
    update(x,y){

        if(Useragnt.pc){
            this.pointer.x = x;
            this.pointer.y = y;
        }else{
            this.pointer.x = x;
            this.pointer.y = -y;
        }
        // console.log(this.pointer);
    }
}